export var typedObjectKeys = function (obj) {
    return Object.keys(obj);
};
//# sourceMappingURL=typedObjectKeys.js.map